import React from 'react';
import { Mathround } from './Mathround';
import { Button } from '@chakra-ui/react';
import SettingsIcon from '@mui/icons-material/Settings';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import StorageIcon from '@mui/icons-material/Storage';
import SpeedIcon from '@mui/icons-material/Speed';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import { Box } from '@chakra-ui/react';

class Header extends React.Component {
  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps.redux.settings.autoSave)
      localStorage.setItem('gameData', JSON.stringify(nextProps.redux));
  }

  openSettings = () => {
    const { redux } = this.props;
    redux.toggleSettingsPopupAction(true);
  };

  handleClick = () => {
    this.props.redux.addCoinsAction(100);
  };

  handleClick2 = () => {
    this.props.redux.addCoinsAction(100000);
  };

  render() {
    const { redux } = this.props;
    return (
      <Box>
        <Box className="header">
          <Box className="header__row">
            <Button
              className="header__settings-icon"
              onClick={this.openSettings}
              disabled
            >
              <SettingsIcon />
            </Button>
            <div className="header__column">
              <div>
                <AttachMoneyIcon onClick={this.handleClick} />{' '}
                {Mathround(redux.resources.coins, 2)}
              </div>
              <div>{}</div>
            </div>
          </Box>
          <Box className="header__row">
            <div>
              <BatteryChargingFullIcon /> {Mathround(redux.resources.energy, 2)}
            </div>
            <div>
              <BeenhereIcon /> {Mathround(redux.upgrades.total, 2)}
            </div>
          </Box>
          <Box className="header__row">
            <div>
              <SpeedIcon /> {redux.drill.speed}
            </div>
            <div>
              <TrackChangesIcon /> {redux.drill.quality}
            </div>
          </Box>
          <Box className="header__row">
            <div>
              <StorageIcon onClick={this.handleClick2} />{' '}
              {Mathround(redux.resources.weight.current, 1)}/
              {Mathround(redux.resources.weight.max, 1)}
            </div>
          </Box>

          <p className="version"></p>
        </Box>
      </Box>
    );
  }
}

export { Header };
